import type { ReactNode } from "react";
import type { PlanFeature, Subscription } from "./types";
import { hasFeature } from "./useSubscription";

const SUPPORT_EMAIL = "support@0todeploy.com";

export function LockedFeature({
  feature,
  featureLabel,
  subscription,
  loading,
  children,
}: {
  feature: PlanFeature;
  featureLabel: string;
  subscription: Subscription | null;
  loading: boolean;
  children: ReactNode;
}) {
  if (hasFeature(feature, subscription, loading)) {
    return <>{children}</>;
  }

  const subject = encodeURIComponent(`Add-on request: ${featureLabel}`);
  const body = encodeURIComponent(
    `Hi,\n\nWe're on the ${subscription?.plan ?? "Basic"} plan and would like to add "${featureLabel}" to our account.\n\nThanks!`,
  );

  return (
    <div className="locked-feature">
      <div className="locked-feature-notice">
        <span className="locked-feature-badge">Advanced plan</span>
        <p>
          <strong>{featureLabel}</strong> isn't included in your current plan. Upgrade to
          Advanced, or{" "}
          <a href={`mailto:${SUPPORT_EMAIL}?subject=${subject}&body=${body}`}>
            contact support
          </a>{" "}
          to add it individually.
        </p>
      </div>
      <div className="locked-feature-content" aria-disabled="true" inert>
        {children}
      </div>
    </div>
  );
}
